module.exports = __webpack_public_path__ + "static/media/linkedin.72ab39d8.png";